import React, { useEffect, useState, useCallback } from 'react';
import '../styles/toast.css';

// Duration a toast stays visible before auto-dismissing.
const AUTO_DISMISS_MS = 4000;

// CSS transition duration for the slide-out animation (must match
// .toast-exiting transition in toast.css). After this delay the toast
// is actually removed from the DOM via onDismiss.
const EXIT_ANIMATION_MS = 250;

// Single toast item. Self-manages its auto-dismiss timer and exit animation.
// The ToastProvider is responsible for mounting/unmounting this component as
// entries are added to and removed from the queue.
function Toast({ message, type = 'info', onDismiss }) {
  const [isExiting, setIsExiting] = useState(false);

  const dismiss = useCallback(() => {
    setIsExiting(true);
    setTimeout(onDismiss, EXIT_ANIMATION_MS);
  }, [onDismiss]);

  useEffect(() => {
    const timer = setTimeout(dismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [dismiss]);

  return (
    <div
      className={`toast toast-${type}${isExiting ? ' toast-exiting' : ''}`}
      role={type === 'error' ? 'alert' : 'status'}
    >
      <span className="toast-message">{message}</span>
      <button
        type="button"
        className="toast-close"
        onClick={dismiss}
        aria-label="Dismiss notification"
      >
        ×
      </button>
    </div>
  );
}

export default Toast;
